<div class="footer-shell @container">
  <div class="footer-shell__intro">
    <a class="footer-shell__brand" [routerLink]="['/']">
      <div class="footer-shell__logo">
        <mat-icon>verified</mat-icon>
      </div>
      <span>MindYourTax</span>
    </a>

    <p class="footer-shell__desc">
      Expert-assisted income tax, GST, and compliance services for individuals,
      professionals, and businesses across India.
    </p>

    <div class="footer-shell__contact">
      <div class="footer-shell__contact-item">
        <mat-icon>location_on</mat-icon>
        <span class="footer-shell__contact-text">
          House no -03, Ganigarahalli Main Road, Chikkabanavara, Bengaluru
        </span>
      </div>
      <div class="footer-shell__contact-item">
        <mat-icon>outgoing_mail</mat-icon>
        <a class="footer-shell__contact-text" href="mailto:contactus@mindyourtax.in">contactus&#64;mindyourtax.in</a>
      </div>
      <div class="footer-shell__contact-item">
        <mat-icon>phone_in_talk</mat-icon>
        <a class="footer-shell__contact-text" href="tel:+918521015658">+91-8521015658</a>
      </div>
    </div>

    <div class="footer-shell__socials">
      <a href="https://www.facebook.com/mindyourtax" target="_blank">
        <mat-icon class="custom-icon" svgIcon="facebook"></mat-icon>
      </a>
      <a [href]="whatsappCtaHref" target="_blank" rel="noopener noreferrer">
        <mat-icon class="custom-icon" svgIcon="whatsapp"></mat-icon>
      </a>
      <a href="https://www.instagram.com/mindyourtax/" target="_blank">
        <mat-icon class="custom-icon" svgIcon="instagram"></mat-icon>
      </a>
      <a href="https://www.linkedin.com/company/mind-your-tax/" target="_blank">
        <mat-icon class="custom-icon" svgIcon="linkedin"></mat-icon>
      </a>
      <a href="https://twitter.com/mindyourtax" target="_blank">
        <mat-icon class="custom-icon" svgIcon="twitterx"></mat-icon>
      </a>
      <a href="https://in.pinterest.com/mindyourtax/" target="_blank">
        <mat-icon class="custom-icon" svgIcon="pinterest"></mat-icon>
      </a>
    </div>
  </div>

  <div class="footer-shell__links">
    @for (category of configService.categoryList; track category.categoryId) {
    <div class="footer-shell__column">
      <h3>{{ category.description }}</h3>
      <div class="footer-shell__divider"></div>
      @for (item of configService.subCategoryListByCategoryIdMap.get(category.categoryId); track item.subCategoryId) {
      <a [routerLink]="['packages', 'details', item.routeIdentifier]">
        {{ item.subCategoryDescription }}
      </a>
      }
    </div>
    }

    <div class="footer-shell__column">
      <h3>Company</h3>
      <div class="footer-shell__divider"></div>
      <a [routerLink]="['/']">Home</a>
      <a [routerLink]="['about-us']">About Us</a>
      <a [routerLink]="['blogs', 'dashbaord']">Blogs</a>
      <a [routerLink]="['contact-us']">Contact Us</a>
    </div>

    <div class="footer-shell__column">
      <h3>Locations</h3>
      <div class="footer-shell__divider"></div>
      <a [routerLink]="['services', 'best-ca-firm-in-bangalore']">Bangalore</a>
      <a [routerLink]="['services', 'best-ca-firm-in-delhi']">Delhi</a>
      <a [routerLink]="['services', 'best-ca-firm-in-mumbai']">Mumbai</a>
    </div>
  </div>
</div>
